import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import Services from './pages/Services';
import About from './pages/About';
import RequestService from './pages/RequestService';
import JoinTeam from './pages/JoinTeam';
import Contact from './pages/Contact';
import PlatformGuide from './pages/PlatformGuide';
import TermsPage from './pages/TermsPage';
import { CLIENT_TERMS, FREELANCER_TERMS } from './data/terms';
import { Toaster } from './components/ui/toaster';
import { AuthProvider } from './marketplace/AuthContext';
import AuthPage from './marketplace/AuthPage';
import PostJob from './marketplace/PostJob';
import BrowseJobs from './marketplace/BrowseJobs';
import JobDetail from './marketplace/JobDetail';
import ClientDashboard from './marketplace/ClientDashboard';
import OperativeDashboard from './marketplace/OperativeDashboard';
import OperativeProfile from './marketplace/OperativeProfile';
import FindProfessional from './marketplace/FindProfessional';
import ProfessionalDetail from './marketplace/ProfessionalDetail';
import AdminDashboard from './marketplace/AdminDashboard';
import AdminFinance from './marketplace/AdminFinance';
import VerifyOperative from './marketplace/VerifyOperative';
import Messages from './marketplace/Messages';
import GoogleCallback from './marketplace/GoogleCallback';
import { RequestSignup, JoinSignup } from './marketplace/SignupFlow';
import { ForgotPassword, ResetPassword, ChangePassword } from './marketplace/PasswordPages';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/our-services" element={<Services />} />
            <Route path="/about-us" element={<About />} />
            <Route path="/request-a-service" element={<RequestSignup />} />
            <Route path="/join-our-team" element={<JoinSignup />} />
            <Route path="/request-a-service-form" element={<RequestService />} />
            <Route path="/join-our-team-form" element={<JoinTeam />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/guide" element={<PlatformGuide />} />
            <Route path="/help" element={<PlatformGuide />} />
            <Route path="/client-terms" element={<TermsPage data={CLIENT_TERMS} requiredRef="request-form" />} />
            <Route path="/freelancer-terms" element={<TermsPage data={FREELANCER_TERMS} requiredRef="join-form" />} />
            <Route path="/auth" element={<AuthPage />} />
            <Route path="/auth/callback" element={<GoogleCallback />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/change-password" element={<ChangePassword />} />
            <Route path="/post-a-job" element={<PostJob />} />
            <Route path="/browse-jobs" element={<BrowseJobs />} />
            <Route path="/jobs/:id" element={<JobDetail />} />
            <Route path="/dashboard/client" element={<ClientDashboard />} />
            <Route path="/dashboard/operative" element={<OperativeDashboard />} />
            <Route path="/profile/operative" element={<OperativeProfile />} />
            <Route path="/find-a-professional" element={<FindProfessional />} />
            <Route path="/professionals/:id" element={<ProfessionalDetail />} />
            <Route path="/messages" element={<Messages />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/finance" element={<AdminFinance />} />
            <Route path="/verify" element={<VerifyOperative />} />
          </Routes>
        </Layout>
        </AuthProvider>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
